import { Component } from '@angular/core';
import { ADVISORY_BOOKING_URL, HERO_BULLETS, HERO_IMAGES } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-hero',
  templateUrl: './landing-hero.component.html',
  styleUrls: ['./landing-hero.component.scss'],
})
export class LandingHeroComponent {
  readonly advisoryBookingUrl = ADVISORY_BOOKING_URL;
  readonly bullets = HERO_BULLETS;
  readonly heroImages = HERO_IMAGES;
}
